<template>
  <div :class="[ verticalDisplay ? 'container-vertical' : '' ]">
    <div v-if='horizontalDisplay' class="is-horizontal-divider" />
    <div v-if='verticalDisplay' class="is-vertical-divider" />
  </div>
</template>

<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      required: false,
      default: false
    },
    horizontal: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    horizontalDisplay () {
      return !this.vertical && this.horizontal
    },
    verticalDisplay () {
      return this.vertical && this.horizontal
    }
  }
}
</script>

<style lang="scss" scoped>
.is-horizontal-divider {
  margin: 1.5rem 0;
  border-top-width: 1px;
  display: block;
  position: relative;
  border-top: 0.0625rem solid #dbdbdb;
  text-align: center;
}
.is-vertical-divider {
  margin: 0px 1rem 0px 1rem;
  display: block;
  position: relative;
  border-left: 0.1225rem solid #dbdbdb;
  text-align: center;
  height: 100%;
  width: 0px;
}
.container-vertical {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/general/divider.vue